export const createMarkup = (html): { __html: string } => {
  // return {__html: DOMPurify.sanitize(html)};
  return { __html: html };
};
